export const formatDateComment = (fecha) => {
    const date = new Date(fecha)
    const now = new Date()
    const diffInMs = now - date
    const diffInMinutes = Math.floor(diffInMs / 1000 / 60)
    const diffInHours = Math.floor(diffInMinutes / 60)
    const remainingMinutes = diffInMinutes % 60

    if (diffInHours < 1 && diffInMinutes < 60) {
        // Menos de 1 hora, muestra minutos
        return `Hace ${diffInMinutes} minutos.`
    } else if (diffInHours < 2) {
        // Menos de 2 horas, muestra "X horas y Y minutos"
        return `Hace ${diffInHours} hora y ${remainingMinutes} minutos`
    } else if (diffInHours < 24) {
        // Menos de 24 horas, muestra horas
        return "Hace " + diffInHours + " horas"
    } else {
        // Más de 24 horas, muestra la fecha formateada sin segundos
        const formattedDate = new Date(fecha).toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
        return formattedDate;
    }
}

  export const formatDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.ToDateTimeString();
  };